import { api, REQUEST_TYPE } from 'store/api'
import { ModuleTags } from './consts'
import { getScopeOrder, scopeOrdersByTypeSorted } from 'graphql/scopeOrders.graphql'

const JSON_FIELDS = ['shippingAddress', 'items', 'shipments', 'audit']

const parseJson = value => {
  if (typeof value !== 'string') {
    return value
  }

  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

export const parseScopeOrder = order =>
  JSON_FIELDS.reduce((parsed, field) => ({ ...parsed, [field]: parseJson(order[field]) }), { ...order })

const ORDERS_PATH = '/ops/v1/orders/scope'

export const ScopeOrders = api.injectEndpoints({
  endpoints: build => ({
    listScopeOrders: build.query({
      query: () => ({
        type: REQUEST_TYPE.GRAPHQL_FETCH_ALL,
        query: scopeOrdersByTypeSorted,
        queryName: 'scopeOrdersByTypeSorted',
        variables: { type: 'ScopeOrder', sortDirection: 'DESC' }
      }),
      transformResponse: orders => orders.filter(order => !order._deleted).map(parseScopeOrder),
      providesTags: [ModuleTags.ScopeOrders]
    }),
    getScopeOrder: build.query({
      query: ({ id }) => ({
        type: REQUEST_TYPE.GRAPHQL,
        query: getScopeOrder,
        variables: { id }
      }),
      transformResponse: res => (res?.getScopeOrder ? parseScopeOrder(res.getScopeOrder) : null),
      providesTags: [ModuleTags.ScopeOrders]
    }),
    getScopeOrdersConfiguration: build.query({
      query: () => ({ type: REQUEST_TYPE.GET, path: `${ORDERS_PATH}/configuration` })
    }),
    createScopeOrderShipment: build.mutation({
      query: ({ id, shippingMethod }) => ({
        type: REQUEST_TYPE.POST,
        path: `${ORDERS_PATH}/${id}`,
        data: { shippingMethod }
      }),
      invalidatesTags: [ModuleTags.ScopeOrders]
    }),
    updateScopeOrder: build.mutation({
      query: ({ id, ...changes }) => ({
        type: REQUEST_TYPE.PATCH,
        path: `${ORDERS_PATH}/${id}`,
        data: changes
      }),
      invalidatesTags: [ModuleTags.ScopeOrders]
    }),
    getPracticeScopeOrderTracking: build.query({
      query: () => ({ type: REQUEST_TYPE.GET, apiName: 'grinApi', path: '/billing/v1/orders/scopes/tracking' }),
      transformResponse: res => res?.orders || []
    }),
    resumeScopeOrderShipbob: build.mutation({
      query: ({ id }) => ({ type: REQUEST_TYPE.POST, path: `${ORDERS_PATH}/${id}/resume` }),
      invalidatesTags: [ModuleTags.ScopeOrders]
    })
  })
})

export const {
  useListScopeOrdersQuery,
  useGetScopeOrderQuery,
  useGetScopeOrdersConfigurationQuery,
  useCreateScopeOrderShipmentMutation,
  useUpdateScopeOrderMutation,
  useResumeScopeOrderShipbobMutation,
  useGetPracticeScopeOrderTrackingQuery
} = ScopeOrders
